goog.provide('el8.model.identify');

// TODO JSCLEAN Convert all of these. Should be a method of an el8_Entity called "is()"

el8.model.identify = (function() {
    return {

        isReport: function( item ) {
            return ( item.getModelClass().match('Report') !== null && item.getModelClass().match('Order') === null );
        },
        isPatientFormCollection: function(item) {
          // not a true model identifier but seems like the right place to put the logic for reuse purposes
          return this.isReport(item) && (!!item.getFormCollection());
        },
        isOrder: function( item ) {
            return (item.getModelClass().match('Order') !== null) &&
                    (item.getModelClass().match('MedOrder') === null);
        },
        isInjection: function( item ) { 
          return Boolean(item) && item.getModelClass() === 'Injection';
        },
        isPrescription: function( item ) {
            return (item.getModelClass() === 'Prescription') || (item.getModelClass() === 'MedOrder');
        },
        isMedOrderThread: function(item) {
            return (item.getModelClass() === 'MedOrderThread');
        },
        isDiscontinueMedOrder: function( item ) {
            return ( item.getModelClass() === 'DiscontinueMedOrder' );
        },
        isDenialMedOrder: function( item ) {
            return ( item.getModelClass() === 'DenialMedOrder' );
        },
        isNote: function( item ) {
            return this.isVisitNote(item) || this.isNonvisitNote(item);
        },
        isNonvisitNote: function( item ) {
            return ( item.getModelClass() === 'NonvisitNote' );
        },
        isVisitNote: function( item ) {
            return ( item.getModelClass() === 'VisitNote' );
        },
        isThread: function( item ) {
            return ( item.getModelClass() === 'MessageThread' );
        },
        isCheckout: function( item ) {
            return ( item.getModelClass() === 'Checkout' );
        },
        isMessageThread: function(item) {
            return (item.getModelClass() === 'MessageThread');
        },
        isPatientProblem : function(item) {
            return (item.getModelClass() === 'PatientProblem');
        },
        isPatientHistory : function(item) {
            return (item.getModelClass() === 'PatientHistoryItem');
        },
        isConfidentialItem : function(item) {
            return (item.getModelClass() === 'ConfidentialItem');
        },
        isAddendum : function(item) {
            return (item.getModelClass() === 'DocumentAddendum');
        },
        isLetter: function(item) {
            return (item.getModelClass() === 'Letter');
        },
        isLetterReceipt: function(item) {
            return (item.getModelClass() === 'LetterReceipt');
        },
        isDocumentReminderNotification: function(item) {
            return (item.getModelClass() === 'DocumentReminderNotification');
        },
        isPrenatalFlowsheet: function(item) {
            return (item.getModelClass() === 'PrenatalFlowsheet');
        },
        isPrenatalFlowsheetVisitMeasurements: function(item) {
            return (item.getModelClass() === 'PrenatalFlowsheetVisitMeasurements');
        }
    };
})();


el8.model.idToModelClass = function(id, force) {
    var el8TypeCode = id & 0xffff;
    var mClass = el8Globals['EL8_ID_TYPES'][el8TypeCode];
    if (force) { return mClass; }
    if (mClass === 'RxHistoryDownloadMedOrder') {
        return 'MedOrder';
    } else if (mClass === 'RxHistoryDownloadMedOrderThread') {
        return 'MedOrderThread';
    } else if (mClass === 'RxHistoryDownloadMedOrderFill') {
        return 'MedOrderFill';
    }
    return mClass;
};

el8.model.modelClassToIdType = function(mClass) {
    for (var type in el8Globals['EL8_ID_TYPES']) {
        if (el8Globals['EL8_ID_TYPES'][type] === mClass) {
            return type;
        }
    }
};

/**
 * Determines if a document is a patient letter, handling different model types.
 * - LetterReceipt has isPtLetter() method
 * - Letter has isSendToPatient() method  
 * - Access letterSummaries has neither, defaults to false (provider letter)
 * 
 * @param {object} document - Letter, LetterReceipt, or letterSummary object
 * @return {boolean} True if this is a patient letter
 */
el8.model.isPatientLetter = function(document) {
    if (typeof document.isPtLetter === 'function') {
        return document.isPtLetter();
    } else if (typeof document.isSendToPatient === 'function') {
        return document.isSendToPatient();
    }
    // Default to false for Access letterSummaries or unknown types
    return false;
};
